import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { UserRoles } from '~entities/users/model/types';
import { checkMinRoleValue } from '~shared/utils/role-guard';

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

export const Route = createFileRoute('/_auth/_layout/recitals')({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  pendingComponent: PendingComponent,
  component: () => <Outlet />,
});
